export default __webpack_public_path__ + "static/media/shopifyUnlock.1ca6216f.svg";